export const MOBILE_BREAKPOINT = 600;

export const isMobile = (): boolean => {
	if (typeof window === 'undefined') {
		return false;
	}

	return window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`).matches;
};
